const host = 'https://api.dev.khero.cloud';
const version = 'v1';

export const environment = {
  production: false,
  api: {
    base: `${host}/${version}`,
  },
  firebase: {
    options: {
      projectId: "k-hero",
      appId: "1:50173436684:web:f5265498b5894b5df31f29",
      storageBucket: "k-hero.firebasestorage.app",
      apiKey: "AIzaSyBjK74irNuKWs5KREJb6CU3Dxb5O8yGxIw",
      authDomain: "k-hero.firebaseapp.com",
      messagingSenderId: "50173436684"
    },
  },
  refresh_token_every_seconds: 300,
  show_exercise_code_in_list: true,
};
